import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import './Violation.css';

const InfoViolation = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [rec, setRec] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    load();
  }, [id]);

  const load = async () => {
    try {
      const token = localStorage.getItem('token');
      const r = await axios.get(
        `${process.env.REACT_APP_BASE_API_URL}/driver-violations/${id}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      const d = r.data || {};
      // Normalize fields and handle REMARKS CLOB/stream objects
      const normalized = {
        VIOLATION_ID: d.VIOLATION_ID || d.violation_id || null,
        JOURNEY_PLANE_NO: d.JOURNEY_PLANE_NO || d.journey_plane_no || '',
        SCHEDULED_VEHICLE: d.SCHEDULED_VEHICLE || d.scheduled_vehicle || '',
        DRIVER_NAME: d.DRIVER_NAME || d.driver_name || '',
        DRIVER_PHONE: d.DRIVER_PHONE || d.driver_phone || '',
        CARRIER: d.CARRIER || d.carrier || '',
        VIOLATION: d.VIOLATION || d.violation || '',
        VIOLATION_TIME: d.VIOLATION_TIME || d.violation_time || null,
        IVMS_POINT: d.IVMS_POINT || d.ivms_point || '',
        VIOLATION_STATUS: d.VIOLATION_STATUS || d.violation_status || d.VIOLATION_STATUS || '',
        DATE_RESOLVED: d.DATE_RESOLVED || d.date_resolved || null,
        RESOLVED: d.RESOLVED || d.resolved || 'N',
        COUNSELLED_BY: d.COUNSELLED_BY || d.counselled_by || '',
        ACTION_TAKEN: d.ACTION_TAKEN || d.action_taken || ''
      };

      // Handle REMARKS robustly: prefer string, treat empty objects as empty string, otherwise stringify non-empty objects
      if (d.REMARKS !== undefined && d.REMARKS !== null) {
        if (typeof d.REMARKS === 'string') {
          normalized.REMARKS = d.REMARKS;
        } else if (typeof d.REMARKS === 'object') {
          try {
            const keys = Object.keys(d.REMARKS);
            normalized.REMARKS = keys.length === 0 ? '' : JSON.stringify(d.REMARKS);
          } catch (e) {
            normalized.REMARKS = '';
          }
        } else {
          normalized.REMARKS = String(d.REMARKS);
        }
      } else {
        normalized.REMARKS = '';
      }

      setRec(normalized);
    } catch (error) {
      console.error('Error fetching violation:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <div style={{ padding: '20px', textAlign: 'center' }}>Loading...</div>;
  if (!rec) return <div style={{ padding: '20px', textAlign: 'center', color: 'red' }}>Violation not found.</div>;

  const isResolved = rec.VIOLATION_STATUS === 'RESOLVED' || rec.RESOLVED === 'Y';

  return (
    <div className="info-violation-container">
      <button className="close-button" onClick={() => navigate('/driver-violations')}>×</button>
      <h2 className="info-violation-header">📋 Violation Details</h2>

      <div className="info-violation-details">
        <div className="info-violation-row">
          <div className="info-violation-label">Driver Name:</div>
          <div className="info-violation-value">{rec.DRIVER_NAME || '--'}</div>
        </div>

        <div className="info-violation-row">
          <div className="info-violation-label">Vehicle:</div>
          <div className="info-violation-value">{rec.SCHEDULED_VEHICLE || '--'}</div>
        </div>

        <div className="info-violation-row">
          <div className="info-violation-label">Carrier:</div>
          <div className="info-violation-value">{rec.CARRIER || '--'}</div>
        </div>

        <div className="info-violation-row">
          <div className="info-violation-label">Journey / JP No:</div>
          <div className="info-violation-value">{rec.JOURNEY_PLANE_NO || '--'}</div>
        </div>

        <div className="info-violation-row">
          <div className="info-violation-label">Violation Type:</div>
          <div className="info-violation-value"><strong>{rec.VIOLATION || '--'}</strong></div>
        </div>

        <div className="info-violation-row">
          <div className="info-violation-label">Violation Time:</div>
          <div className="info-violation-value">
            {rec.VIOLATION_TIME ? new Date(rec.VIOLATION_TIME).toLocaleString('en-US', { timeZone: 'Asia/Muscat' }) : '--'}
          </div>
        </div>

        <div className="info-violation-row">
          <div className="info-violation-label">IVMS Point:</div>
          <div className="info-violation-value">{rec.IVMS_POINT || '--'}</div>
        </div>

        <div className="info-violation-row">
          <div className="info-violation-label">Status:</div>
          <div className="info-violation-value">
            <span className={isResolved ? 'violation-status-resolved' : 'violation-status-open'}>
              {rec.VIOLATION_STATUS || (isResolved ? 'RESOLVED' : 'OPEN')}
            </span>
          </div>
        </div>

        <div className="info-violation-row">
          <div className="info-violation-label">Remarks:</div>
          <div className="info-violation-value">{rec.REMARKS || '--'}</div>
        </div>

        {isResolved && (
          <>
            <div className="info-violation-row">
              <div className="info-violation-label">Counselled By:</div>
              <div className="info-violation-value">{rec.COUNSELLED_BY || '--'}</div>
            </div>

            <div className="info-violation-row">
              <div className="info-violation-label">Action Taken:</div>
              <div className="info-violation-value">{rec.ACTION_TAKEN || '--'}</div>
            </div>

            <div className="info-violation-row">
              <div className="info-violation-label">Resolution Date:</div>
              <div className="info-violation-value">
                {rec.DATE_RESOLVED ? new Date(rec.DATE_RESOLVED).toLocaleString('en-US', { timeZone: 'Asia/Muscat' }) : '--'}
              </div>
            </div>
          </>
        )}
      </div>

      <div className="info-violation-actions">
        {isResolved && (
          <button className="warning-letter" onClick={() => navigate(`/handle-violation/${id}`)}>
            View Signed Warning Letter
          </button>
        )}
        <button className="back" onClick={() => navigate('/driver-violations')}>
          ← Back to Violations
        </button>
      </div>
    </div>
  );
};

export default InfoViolation;
